<template>
  <transition name="slide-down">
    <div ref="ddRef" class="drop-down" v-if="showDropDown && optionsList.length > 0">
      <span class="drop-down-option" v-for="(option, $index) in optionsList" :key="option[valueProp]" @click="selectOption($index)" tabindex="-1" :class="{'active': activeOption === $index}">{{option[displayProp]}}</span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    optionsList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    },
    displayProp: {
      type: String,
      required: true,
      default: function() {
        return ''
      }
    },
    valueProp: {
      type: String,
      required: true,
      default: function() {
        return ''
      }
    },
    eventOnInput: {
      // type: KeyboardEvent,
      required: true,
      default: function() {
        return null
      }
    }
  },
  watch: {
    eventOnInput: function(event) {
      if (this.showDropDown == false) {
        return false
      }

      if (event.keyCode === 40) {
        event.preventDefault()
        // down key pressed
        this.activeOption = ++this.activeOption % this.optionsList.length
      } else if (event.keyCode === 38) {
        // up key pressed
        this.activeOption = --this.activeOption % this.optionsList.length
      } else if (event.keyCode === 13) {
        // Enter key
        let selectedOption = this.optionsList[this.activeOption]
        this.setValueProp(selectedOption)
        this.$emit('onselect', { selectedOption: selectedOption })
        this.showDropDown = false
      } else if (event.keyCode === 27) {
        this.showDropDown = false
      }
    },
    optionsList: {
      handler: function(newValue) {
        this.showDropDown = true
        this.activeOption = 0
      },
      immediate: true
    }
  },
  data: function() {
    return {
      activeOption: 0,
      destination: '',
      showDropDown: false
    }
  },
  methods: {
    setValueProp: function(option) {
      option.value = option[this.valueProp]
    },
    selectOption: function(index) {
      let selectedOption = this.optionsList[index]
      this.setValueProp(selectedOption)
      this.$emit('onselect', { selectedOption: selectedOption })
      this.showDropDown = false
    }
  }
}
</script>

<style lang="scss">
.drop-down-container {
  position: relative;
  .drop-down {
    position: absolute;
    background: white;
    border: 1px solid darkgray;
    top: 35px;
    margin-left: -10px;
    border-radius: 5px;
    // max-height: 200px;
    overflow-y: auto;
    width: 100%;
    z-index: 6;
    left: 10px;
    max-width: 266px;
    box-shadow: (0px, 2px, 6px, 0px, rgba(0, 0, 0, 0.1));

    &:hover {
      .drop-down-option {
        &.active {
          background: #fff;
          color: #000;
        }
      }
    }
    .hd-container-fluid {
      overflow: visible;
    }
    .drop-down-option {
      padding: 5px 10px;
      font-size: 16px;
      display: block;
      cursor: pointer;

      &.active {
        background: #be3f52;
        color: #fff;
      }

      &:hover {
        background: #be3f52 !important;
        color: #fff !important;
      }
    }
  }
}
.drop-down-option {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/autocomplete.vue